import React from 'react';

import { PageErrorUi, UiKit } from 'components';
import Loader from '../Loader';
import SubReasons from './SubReasons';
import { useRequestReasonConfig } from '../context';

export default function Form({ children = null }) {
  const {
    mode,
    data,
    errors,
    isError,
    isFormOpen,
    isDisabled,
    isProcessing,
    onLoad,
    onSave,
    onChange,
    onFormClose
  } = useRequestReasonConfig();

  const confirmButtonText = mode === 'create' ? 'Create' : 'Save';
  const heading = `${mode === 'edit' ? 'Edit' : 'Create New'} Reason`;
  const subHeading =
    mode === 'edit'
      ? 'Edit the return reason your customer can select when requesting a return or exchange.'
      : 'Create a return reason your customer can select when requesting a return or exchange.';

  return (
    <UiKit.Modal
      size="md"
      isOpen={isFormOpen}
      onClose={onFormClose}
      isDisabled={isDisabled}
      isProcessing={isProcessing}
    >
      <UiKit.Modal.Header title="Return Reason" />
      <UiKit.Modal.Body>
        <UiKit.Flex direction="column" gap={24}>
          <UiKit.Flex direction="column" gap={4}>
            <UiKit.Title weight="normal">{heading}</UiKit.Title>
            <UiKit.Text variant={500}>{subHeading}</UiKit.Text>
          </UiKit.Flex>
          <PageErrorUi
            isError={isError}
            msg="Unable to load the reason details."
            onReload={onLoad}
          >
            <Loader>
              <UiKit.Input
                label="Reason Name"
                value={data.name}
                onChange={name => onChange({ name })}
                placeholder="Eg. Ordered incorrect product"
                disabled={isProcessing || isDisabled}
                error={errors.name}
              />
              <UiKit.Card>
                <UiKit.Card.Body>
                  <UiKit.Flex direction="column" gap={16}>
                    <UiKit.Flex direction="column" gap={4}>
                      <UiKit.Title size="sm" weight="bold">
                        Sub Reasons
                      </UiKit.Title>
                      <UiKit.Text variant={500}>
                        Optionally add Sub Reasons to collect more specific
                        feedback. For example, "Wrong Size" might include
                        sub-reasons like Too Long, Too Short, Too Loose, or Too
                        Tight.
                      </UiKit.Text>
                    </UiKit.Flex>
                    <UiKit.Separator variant="dashed" />
                    <SubReasons />
                  </UiKit.Flex>
                </UiKit.Card.Body>
              </UiKit.Card>
            </Loader>
          </PageErrorUi>
        </UiKit.Flex>
      </UiKit.Modal.Body>
      <UiKit.Modal.Footer onConfirm={onSave} confirmBtnText={confirmButtonText}>
        {children}
      </UiKit.Modal.Footer>
    </UiKit.Modal>
  );
}
